import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { AllowedCountry } from 'types/authentication/Profile'

export const getAllowedCountries = async (): Promise<AllowedCountry[]> => {
  return requestApi({
    url: '/platform/v1/accounts/countries',
    method: 'GET',
    baseUrl: BASE_API_URL,
  })
}
